<template>
    <!-- 变体信息 -->
    <div class="Minister-top information">
        <div class="Minister-top-top Ministerbackground">
            <div class="Minister-top-left Minister-top-color">变体信息</div>
        </div>
        <div class="information_content" style="margin-bottom: 20px">
            <div class="information_input">
                <div class="information_Title">
                    <span class="tips">*</span>
                    销售类型
                </div>
                <div class="input_el input_span mT-5">
                    <el-radio v-removeAriaHidden v-model="formData.radio" label="one"
                        @input='variantChange'>父体</el-radio>
                    <el-radio v-removeAriaHidden v-model="formData.radio" label="two"
                        @input='variantChange'>变体</el-radio>
                </div>
            </div>
            <div >
                <div class="information_input">
                    <div class="information_Title">
                        <span class="tips">*</span>
                        {{ formData.radio == 'one' ? 'SKU' : '父SKU' }}
                    </div>
                    <div class="input_el input_span">
                        <el-input class="width97" placeholder="请输入Sku" v-model="formData.Sku"></el-input>
                    </div>
                </div>
                <div class="information_input mT-10">
                    <div class="information_Title">产品属性</div>
                    <div class="shuxing_box">
                        <div class="item_shuxing" v-for="(item, index) in topShuxingArr" :key="index">
                            <div class="shuxing_label">
                                <span class="shuxing_label_bitian" v-if="item.required == 1">*</span>
                                {{ item.titleChinese }}
                                <p>{{ item.name }}</p>
                            </div>
                            <el-tooltip placement="right-start">
                                <div slot="content" class="el_tip_box">
                                    {{ item.descriptionChinese }}
                                </div>
                                <img :src="urlQueImg" class="item_img" alt />
                            </el-tooltip>
                            <div style="width: 65%" class="mL-10" :class="{ flex: item.children.length < 6 }">
                                <div style="width: 100%" v-for="(items, index) in oneTopShuxingArr[index]" :key="index">
                                    <el-date-picker class="shuxing_input"
                                        v-if="items.oneOfValue != null && items.oneOfValue == 'date'"
                                        v-model="items.publishProduct" :placeholder="'请选择' + items.titleChinese"
                                        format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                    <el-input :disabled="isChakan || system < 5"
                                        v-else-if="items.enumValue == null && items.type == 'string' || items.type == 'array'"
                                        class="shuxing_input" autosize :placeholder="'请输入' + items.titleChinese"
                                        v-model="items.publishProduct" show-word-limit
                                        :type="items.maxLength == null ? 'input' : 'textarea'"
                                        :maxlength="items.maxLength">
                                    </el-input>
                                    <el-input :disabled="isChakan || system < 5"
                                        v-else-if="items.type == 'integer' || items.type == 'number' && items.enumValue == null"
                                        class="shuxing_input" autosize :placeholder="'请输入' + items.titleChinese"
                                        v-model="items.publishProduct" show-word-limit type="number"
                                        :max="items.maximum" @input="productInput(items)" :maxlength="items.maxLength">
                                    </el-input>
                                    <el-select :router="true" class="shuxing_input" v-else
                                        v-model="items.publishProduct" clearable filterable
                                        :placeholder="'请选择' + items.titleChinese">
                                        <el-option v-for="selectItem in items.enumValue" :key="selectItem"
                                            :label="selectItem" :value="selectItem">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <div class="item_shuxing" v-if="purchasable_offer && formData.radio == 'one'">
                            <div class="shuxing_label">
                                {{ purchasable_offer.titleChinese }}
                                <p>{{ purchasable_offer.name }}</p>
                            </div>
                            <el-tooltip placement="right-start">
                                <div slot="content" class="el_tip_box">
                                    {{ purchasable_offer.descriptionChinese }}
                                </div>
                                <img :src="urlQueImg" class="item_img" alt />
                            </el-tooltip>
                            <div style="width: 65%" class="mL-10">
                                <new-recursive-input :data="purchasable_offer" :purchasable_offer_data="purchasable_offer_data" :isChakan="isChakan"
                                        :system="system" :parent="purchasable_offer" ></new-recursive-input>
                                <!-- <recursive-input :data="purchasable_offer" :isChakan="isChakan" :system="system"
                                    :parent="purchasable_offer"></recursive-input> -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="information_input">
                    <div class="information_Title">
                        <span class="tips">*</span>
                        父SKU
                    </div>
                    <div class="input_el input_span">
                        <el-input class="width97" placeholder="请输入父Sku" v-model="formData.Sku"></el-input>
                    </div>
                </div> -->
                <template v-if="formData.radio === 'two'">
                    <div class="information_input">
                    <div class="information_Title">
                        <span class="tips">*</span>
                        变体主题
                    </div>
                    <div class="input_el input_span mT-5">
                        <el-select class="width97 w-100" v-model="formData.bianti" placeholder="请选择变体主题"
                            @change="selectVariantTitle" clearable filterable>
                            <el-option v-for="item in options" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="color: red;margin-left: 150px;" class="mT-5">
                    温馨提示: 切换变体主题后变体将全部清空
                </div>
                <div class="information_input" v-for="(item, index) in variantTitle" :key="item">
                    <div class="information_Title cur" @click="variantPreset(item)">
                        <span class="tips">*</span>
                        {{ item }}
                    </div>
                    <div class="input_el input_span mT-5">
                        <el-input v-model="shuRuVariant[index]"
                            :placeholder="'请输入' + item + ',多个变体请使用英文逗号隔开(,)'"></el-input>
                    </div>
                </div>
                <div class="information_input">
                    <div class="information_Title">
                        <el-button type="primary" icon="el-icon-plus" @click="addVariant"
                            v-if="!onlineEdit">添加变体</el-button>
                    </div>
                </div>
                <div class="mT-10" style="
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    font-size: 16px;">
                    <!-- 翻译图片 -->
                    <ImageTranslation v-if="aiPower && (aiPower + '').split(',').includes('1')" :imgList="productImages" @onTranslation="onTranslation" :targetCountry="targetCountry" :getParentData="getParentData"></ImageTranslation>
                    <el-button type="primary" @click="imageDialog = true">图片库</el-button>
                    <div v-if="system == 5 && !isChakan">
                        <!-- <el-button type="primary" icon="el-icon-plus" @click="addItem"
                            v-if="!onlineEdit">添加一行</el-button> -->
                        <el-button type="danger" icon="el-icon-delete" @click="removeAll"
                            v-if="!onlineEdit">批量移除</el-button>
                    </div>
                </div>
                <!-- 头部 -->
                <el-table :data="tableList" style="width: 100%; margin-top: 6px" v-loading="load_data"
                    element-loading-text="拼命加载中" border :key="keyNum" @selection-change="on_batch_select"
                    :header-cell-style="iscenter">
                    <el-table-column v-if="system == 5 && !isChakan" width="37" type="selection"></el-table-column>
                    <el-table-column fixed align="center" v-if="system == 5 && !isChakan" width="200"
                        v-for="item in variantTitle" :key="item" :prop="item" :label="item"></el-table-column>
                    <el-table-column width="240" fixed label="产品图" align="center" prop="imageList">
                        <template slot-scope="scope">
                            <div>
                                <!-- 如果有图片 -->
                                <template v-if="scope.row.imageList && scope.row.imageList.length">
                                    <ul class="checked-img-container">
                                        <li class="img-box" v-for="(item, index) in scope.row.imageList.slice(0, 4)"
                                            :key="item.url || index"
                                            @click="Selected_pictures(scope.row, scope.$index)">
                                            <img style="width: 100%;" :src="item.url" alt />
                                            <i class="el-icon-circle-close"
                                                @click.stop="handleRemove(scope.row, index)"></i>
                                        </li>
                                        <li class="img-box" v-if="scope.row.imageList.length > 3">
                                            ...
                                        </li>
                                        <el-button type="mini" icon="el-icon-plus"
                                            @click="selectOnePicture(scope)"></el-button>
                                    </ul>
                                </template>
                                <!-- 如果没有图片 -->
                                <template v-else>
                                    <el-button @click="selectOnePicture(scope)">
                                        选择图片
                                    </el-button>
                                </template>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed prop="SKU" width="320">
                        <template slot="header" slot-scope="scope">
                            <div class="item_header_title">
                                <span class="item_bitian">*</span>SKU编号
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.SKU" @input="val => scope.row.SKU = val.trim()" :disabled="system < 5 || isChakan"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="shopType" width="170">
                        <template slot="header" slot-scope="scope">
                            <div class="item_header_title">
                                <span class="item_bitian">*</span>外部产品类型
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <div class="image_input">
                                <el-select :disabled="system < 5 || isChakan" :router="true" style="width:150px;"
                                    v-model="scope.row.shopType" clearable filterable>
                                    <el-option v-for="selectItem in variantEnumValue" :key="selectItem"
                                        :label="selectItem" :value="selectItem">
                                    </el-option>
                                </el-select>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="shopId" width="220">
                        <template slot="header" slot-scope="scope">
                            <div class="item_header_title">
                                <span class="item_bitian">*</span>外部产品编号
                            </div>
                            <div class="item_header_title">
                                <el-link type="primary" @click="clickBianHao()"
                                    v-if="system == 5 && !isChakan">一键生成</el-link>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <div class="image_input">
                                <el-input v-model="scope.row.shopId" @input="val => scope.row.shopId = val.trim()" :disabled="system < 5 || isChakan">
                                </el-input>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="numberItem" width="100">
                        <template slot="header" slot-scope="scope">
                            <div class="item_header_title">
                                <span class="item_bitian">*</span>项目数
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <div class="image_input">
                                <el-field-input :ref="'numberItemRef' + scope.$index" v-model="scope.row.numberItem" :disabled="system < 5 || isChakan" :type="'number'" :required="numberValidateRule.required === 1" :arrRules="numberValidateRule.map(item => item.type)" :validate-trigger="'input'" label="项目数"></el-field-input>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" v-if="system == 5 && !isChakan" width="115">
                        <template slot="header" slot-scope="scope">
                            <div class="item_header_title">
                                <span class="item_bitian">*</span>可购买优惠
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="primary" @click="shopDiscount(scope, 1)">编辑</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" v-if="system == 5 && !isChakan" width="115">
                        <template slot="header" slot-scope="scope">
                            <div class="item_header_title">
                                <span class="item_bitian">*</span>履行可用性
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="primary" @click="shopDiscount(scope, 2)">编辑</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" v-if="system == 5 && !isChakan" width="115">
                        <template slot="header" slot-scope="scope">
                            <div class="item_header_title">
                                <span class="item_bitian">*</span>标价
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="primary" @click="shopDiscount(scope, 3)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                </template>
                
                <!-- 可购买优惠 -->
                <el-dialog :title="shopTitle" top="5vh" :width="shopIndex == 1 ? '70%' : null" :visible.sync="dialogShopVisible" append-to-body>
                    <div class="information_input mT-10 d-f" v-if="dialogShopVisible">
                        <div class="information_Title">产品属性</div>
                        <div v-if="shopIndex == 1" class="mL-20 shuxing_box">
                            <div class="item_shuxing">
                                <div class="shuxing_label">
                                    {{ purchasable_offer.titleChinese }}
                                    <p>{{ purchasable_offer.name }}</p>
                                </div>
                                <el-tooltip placement="right-start">
                                    <div slot="content" class="el_tip_box">
                                        {{ purchasable_offer.descriptionChinese }}
                                    </div>
                                    <img :src="urlQueImg" class="item_img" alt />
                                </el-tooltip>
                                <div style="width: 65%" class="mL-10">
                                    <new-recursive-input ref="bRef" :data="purchasable_offer" :purchasable_offer_data="purchasable_offer_data" :isChakan="isChakan"
                                        :system="system" :parent="purchasable_offer" @input="onChildInput"></new-recursive-input>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="shopIndex == 2">
                            <div class="mL-20 shuxing_box2">
                                <div class="item_shuxing" v-for="(item, index) in topShuxingArr" :key="index">
                                    <template v-if="item.name == 'fulfillment_availability'">
                                        <div class="shuxing_label">
                                            <span class="shuxing_label_bitian" v-if="item.required == 1">*</span>
                                            {{ item.titleChinese }}
                                            <p>{{ item.name }}</p>
                                        </div>
                                        <el-tooltip placement="right-start">
                                            <div slot="content" class="el_tip_box">
                                                {{ item.descriptionChinese }}
                                            </div>
                                            <img :src="urlQueImg" class="item_img" alt />
                                        </el-tooltip>
                                        <div style="width: 65%" class="mL-10">
                                            <div style="width: 100%" v-for="(items, index) in oneTopShuxingArr[index]"
                                                :key="index">
                                                <el-date-picker class="shuxing_input"
                                                    v-if="items.oneOfValue != null && items.oneOfValue == 'date'"
                                                    v-model="fulfillment_availability_data[items.property]" :placeholder="'请选择' + items.titleChinese"
                                                    format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
                                                </el-date-picker>
                                                <el-input :disabled="isChakan || system < 5"
                                                    v-else-if="items.enumValue == null && items.type == 'string' || items.type == 'array'"
                                                    class="shuxing_input" autosize :placeholder="'请输入' + items.titleChinese"
                                                    v-model="fulfillment_availability_data[items.property]" show-word-limit
                                                    :type="items.maxLength == null ? 'input' : 'textarea'"
                                                    :maxlength="items.maxLength">
                                                </el-input>
                                                <el-input :disabled="isChakan || system < 5"
                                                    v-else-if="items.type == 'integer' || items.type == 'number' && items.enumValue == null"
                                                    class="shuxing_input" autosize :placeholder="'请输入' + items.titleChinese"
                                                    v-model="fulfillment_availability_data[items.property]" show-word-limit type="number"
                                                    :max="items.maximum" @input="fulfillAvailabilityInput(items)" 
                                                    :maxlength="items.maxLength">
                                                </el-input>
                                                <el-select :router="true" class="shuxing_input" v-else
                                                    v-model="fulfillment_availability_data[items.property]" clearable filterable
                                                    :placeholder="'请选择' + items.titleChinese">
                                                    <el-option v-for="selectItem in items.enumValue" :key="selectItem"
                                                        :label="selectItem" :value="selectItem">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </template>
                                    
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="mL-20 shuxing_box2">
                                <div class="item_shuxing" v-for="(item, index) in topShuxingArr" :key="index">
                                    <template v-if="item.name == 'list_price'">
                                        <div class="shuxing_label">
                                            <span class="shuxing_label_bitian" v-if="item.required == 1">*</span>
                                            {{ item.titleChinese }}
                                            <p>{{ item.name }}</p>
                                        </div>
                                        <el-tooltip placement="right-start">
                                            <div slot="content" class="el_tip_box">
                                                {{ item.descriptionChinese }}
                                            </div>
                                            <img :src="urlQueImg" class="item_img" alt />
                                        </el-tooltip>
                                        <div style="width: 65%" class="mL-10">
                                            <div style="width: 100%" v-for="(items, index) in oneTopShuxingArr[index]"
                                                :key="index">
                                                <el-date-picker class="shuxing_input"
                                                    v-if="items.oneOfValue != null && items.oneOfValue == 'date'"
                                                    v-model="list_price_data[items.property]" :placeholder="'请选择' + items.titleChinese"
                                                    format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
                                                </el-date-picker>
                                                <el-input :disabled="isChakan || system < 5"
                                                    v-else-if="items.enumValue == null && items.type == 'string' || items.type == 'array'"
                                                    class="shuxing_input" autosize :placeholder="'请输入' + items.titleChinese"
                                                    v-model="list_price_data[items.property]" show-word-limit
                                                    :type="items.maxLength == null ? 'input' : 'textarea'"
                                                    :maxlength="items.maxLength">
                                                </el-input>
                                                <el-input :disabled="isChakan || system < 5"
                                                    v-else-if="items.type == 'integer' || items.type == 'number' && items.enumValue == null"
                                                    class="shuxing_input" autosize :placeholder="'请输入' + items.titleChinese"
                                                    v-model="list_price_data[items.property]" show-word-limit type="number"
                                                    :max="items.maximum" @input="listPriceInput(items)"
                                                    :maxlength="items.maxLength">
                                                </el-input>
                                                <el-select :router="true" class="shuxing_input" v-else
                                                    v-model="list_price_data[items.property]" clearable filterable
                                                    :placeholder="'请选择' + items.titleChinese">
                                                    <el-option v-for="selectItem in items.enumValue" :key="selectItem"
                                                        :label="selectItem" :value="selectItem">
                                                    </el-option>
                                                </el-select>
                                            </div>
                                        </div>
                                    </template>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="information_input mT-10 d-f" v-if="dialogShopVisible">
                        <div class="information_Title">数据应用</div>
                        <div class="mL-20">
                            <el-select class='shuxing_input' v-model="harderValue" placeholder="(非必选,视情况而定)" clearable>
                                <el-option v-for="item in harderList" :key="item.label" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div slot="footer">
                        <el-button @click="dialogShopVisible = false">取 消</el-button>
                        <el-button type="primary" @click="setShopDiscount">确 定</el-button>
                    </div>
                </el-dialog>
                <!-- 变体预设 -->
                <el-dialog title="变体预设" :visible.sync="dialogVariantVisible" append-to-body>
                    <div>
                        变体值:(多个值用逗号隔开如:red,white,black,)
                        <br />
                        <el-input placeholder="多个值用英文逗号隔开如:red,white,black" class="mT-10" style="width: 100%"
                            size="mini" type="texteara" v-model.trim="variantText"></el-input>
                    </div>
                    <div>
                        <el-tabs class="rs-tab" v-if="recommendSpecs && recommendSpecs.length > 0" tab-position="left">
                            <el-tab-pane v-for="(item, index) in recommendSpecs" :key="index" :label="item.title">
                                <ul>
                                    <li style="padding: 0 3px; cursor: pointer" v-for="(sub_item, i) in item.list"
                                        v-text="sub_item" @click="putText(sub_item)" :key="i"></li>
                                </ul>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <div slot="footer">
                        <el-button @click="dialogVariantVisible = false">取 消</el-button>
                        <el-button type="primary" @click="saveVariantInfoEdit1">确 定</el-button>
                    </div>
                </el-dialog>
                <!-- 已选图片 -->
                <el-dialog title="已选图片" class="uploaderImgVariant" :visible.sync="isShowVariantImg" width="1000px"
                    append-to-body>
                    <div class="image-container">
                        <div class="img-box" v-for="item in variantImages" :key="item.uid">
                            <img :src="item.url" />
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button size="mini" @click="isShowVariantImg = false">取 消</el-button>
                        <el-button size="mini" type="primary" @click="isShowVariantImg = false">确 定</el-button>
                    </div>
                </el-dialog>

                <!-- 所有翻译图片 -->
                <el-dialog title="所有翻译图片" class="uploaderImgVariant" :visible.sync="imageDialog" width="1000px"
                    append-to-body>
                    <div class="btns">
                        <el-button type="primary" @click="changeImg('fanyi_url', 'yuan_url')">使用翻译图</el-button>
                        <el-button type="primary" @click="changeImg('yuan_url', 'fanyi_url')">使用原图</el-button>
                        <el-button type="primary" @click="selectAll">全选</el-button>
                        <el-button type="primary" @click="clearSelect">取消选中</el-button>
                    </div>
                    
                    <div class="image-container">
                        <div class="img-box"  :class="{ active: activeImg.includes(key) }" v-for="(item, key) in fanyiObj" :key="key">
                            <img :src="item.fanyi_url" @click="toggleActive(key)" />
                            <div class="mask" @click="openBigImg(item.fanyi_url)">
                                <i class="custom-icon el-icon-zoom-in"></i>
                            </div>
                        </div>
                    </div>
                </el-dialog>
                <el-dialog
                    :visible.sync="dialogVisible" top="3vh" custom-class="img-dialog" append-to-body close-on-click-modal close-on-press-escape center>
                        <img :src="dialogSrc" class="dialog-img">
                </el-dialog>
                <xuanze-img v-model="xuanzeShow" :img-list="imgSelectList" :active-img="activeImg" @confirm="onConfirmByXuanzeImg"></xuanze-img>
            </div>
        </div>
    </div>
</template>
<script>
import { ajaxGet, ajaxPost, Baseurl } from "@/api/api/api";
import XuanzeImg from "./xuanzeImg.vue";
import colorList from '../../../commodity/product/EstablishProductClassificationModular/Choice/colorList'
import sizeList from '../../../commodity/product/EstablishProductClassificationModular/Choice/sizeList'
import RecursiveInput from "../RecursiveInput.vue";
import NewRecursiveInput from "../NewRecursiveInput.vue";
import ElFieldInput from "@/components/ElFieldInput";
import ImageTranslation from '@/components/ImageTranslation/index.vue';
// import Ajv from "ajv";
// import addFormats from "ajv-formats";
// const ajv = new Ajv({ allErrors: true, strict: false }); // 关闭 strict 可以更宽容
// addFormats(ajv);
export default {
    components: {
        XuanzeImg,
        RecursiveInput,
        NewRecursiveInput,
        ElFieldInput,
        ImageTranslation
    },
    data() {
        return {
            variantPresetIndex: null,
            variantText: null,
            load_data: false,
            // 问号图标
            urlQueImg: require('@/assets/images/wenhao.png'),
            // 变体主题列表
            options: [],
            imgSelectList: [],
            activeImg: [],
            // 变体主题输入
            shuRuVariant: [],
            discount: null,
            // 选择图片
            selectImageIndex: null,
            xuanzeShow: false,
            dialogShopVisible: false,
            keyNum: 0,
            urlDHImg: null,
            headerList: [],
            // 产品属性
            topShuxingArr: [],
            oneTopShuxingArr: [],
            imageList: [],
            harderValue: null,
            harderList: [{
                label: '同步相同颜色',
                value: 1
            },
            {
                label: '同步相同尺寸',
                value: 2
            },
            {
                label: '同步所有',
                value: 3
            }],
            dialogVariantVisible: false,
            variantEnumValue: [
                'ean',
                'gtin',
                'upc'
            ],
            // 变体购买优惠
            purchasable_offer: {},
            // 变体图片
            variantImages: [],
            oldPurchasable_offer: {},
            // 表格总数据
            tableList: [],
            oldTableList: [],
            offerJson: [],
            isShowVariantImg: false, //已选图片
            recommendSpecs: {}, //显示尺寸和颜色的规格
            iscenter: {
                textAlign: "center",
                background: "#f8f8f8",
                color: "#232323",
            },
            // 动态添加表格变体主题列表
            variantTitle: [],
            //在线产品编辑
            onlineEdit: false,
            // 是否点击移除按钮
            isYichu: false,
            batch_select: [],
            variantInfo: null,
            formData: {
                radio: 'one',
                Sku: null,
                offer: [],
                bianti: null
            },
            list_price: [],
            list_priceNum: [],
            fulfillment_availability: [],
            shopTitle: '',
            shopIndex: null,
            purchasable_offer_data: {},
            editIndex: -1,
            fulfillment_availability_data: {},
            list_price_data: {},
            productImages: [],
            targetCountry: '',
            imageDialog: false,
            fanyiObj: {},
            activeImg: [],  //选择要还原的图片
            dialogVisible: false,
            dialogSrc: '',
        }
    },
    props: {
        isChakan: {
            type: Boolean,
            default: false,
        },
        system: {
            type: Number,
            default: 5,
        },
        typeInfo:{},
        allOf:{},
        areaName: {
            type: String
        },
        aiPower:{}
    },
    created() {
        this.tableList = [];
    },
    computed: {
        numberValidateRule() {
            return this.getValidateRule('number_of_items');
        }
    },
    mounted() {
        this.purchasable_offer = this.setPurchasable_offer(JSON.parse(sessionStorage.getItem('purchasable_offer')))
        this.list_price = JSON.parse(sessionStorage.getItem('list_price'));
        this.fulfillment_availability = JSON.parse(sessionStorage.getItem('fulfillment_availability'));
    },
    methods: {
        getParentData(){
            const tableList = this.tableList || [];
            const obj = {};
            const imgData = [];
            for(let i=0; i<tableList.length; i++){
                for(let j=0; j<(tableList[i].imageList || []).length; j++){
                    if(!obj[tableList[i].imageList[j]['url']]){
                        obj[tableList[i].imageList[j]['url']] = true;
                        imgData.push({
                            src: tableList[i].imageList[j]['url'],
                        });
                    }
                }
            }
            return imgData;
        },
        setTargetCountry(){
            this.targetCountry = this.areaName;
        },
        changeImg(targetKey, scoreKey){ //目标key，源key
            // 'fanyi_url', 'yuan_url'

            const urlMap = {};
            this.activeImg.forEach(k => {
                if(this.fanyiObj[k]){
                    const item = this.fanyiObj[k];
                    urlMap[item[scoreKey]] = item[targetKey]; // 原图连接作为key，翻译连接作为值
                }
            });
            for(let i = 0; i < this.tableList.length; i++){
                if(this.tableList[i].imageList && this.tableList[i].imageList.length > 0){
                    for(let j = 0; j < this.tableList[i].imageList.length; j++){
                        const url1 = this.tableList[i].imageList[j].url; //原来的，例：要使用翻译图，这里的url1就是原图的连接
                        if(urlMap[url1]){ // 这里就是翻译图
                            this.$set(this.tableList[i].imageList[j], 'url', urlMap[url1]);
                        }
                    }
                }
            }
        },
        toggleActive(key) {
            const index = this.activeImg.indexOf(key);
            if (index >= 0) {
                this.activeImg.splice(index, 1);
            } else {
                this.activeImg.push(key);
            }
        },
        selectAll(){
            this.activeImg = Object.keys(this.fanyiObj);
        },
        clearSelect(){
            this.activeImg = [];
        },
        openBigImg(src){
            this.dialogSrc = src;
            this.dialogVisible = true;
        },
        onTranslation(res){
            this.fanyiObj = {};
            if(res && res.length > 0){
                const obj = {};
                const obj2 = {};
                for(let i = 0; i < res.length; i++){
                    obj[res[i].sourceImg] = res[i].res.data;
                    obj2[i] = {
                        yuan_url: res[i].sourceImg,
                        fanyi_url: res[i].res.data,
                    }
                }
                for(let i = 0; i < this.tableList.length; i++){
                    if(this.tableList[i].imageList && this.tableList[i].imageList.length > 0){
                        for(let j = 0; j < this.tableList[i].imageList.length; j++){
                            const url1 = this.tableList[i].imageList[j].url;
                            if(obj[url1]){
                                this.$set(this.tableList[i].imageList[j], 'url', obj[url1]);
                            }
                        }
                    }
                }
                this.fanyiObj = obj2;
            }
        },
        getValidateRule(key){
            const rules = [];
            const fun = (schemaNode) => {
                if(!schemaNode || !schemaNode.children) return;
                for(let child of schemaNode.children){
                    if(child.property === key){
                        for(let item of child.children){
                            if(item.property === 'value'){
                                rules.push(item);
                            }
                        }
                    }
                    if(child.children && child.children.length > 0){
                        fun(child);
                    }
                }
            }
            fun({children: this.typeInfo});
            return rules;
        },
        onChildInput(item) {
            if(item.required === 1){ //必填
                if(item.value === null || item.value === undefined || item.value === ''){
                    this.$set(item, 'errorText', '请输入内容');
                    return
                }
                if(item.type === 'integer' || item.type === 'number'){
                    if(isNaN(item.value)){
                        this.$set(item, 'errorText', '请输入数字');
                        return
                    }
                }
                this.$set(item, 'errorText', '');
            }
        },

        

        getData() {
            // 返回所有当前 data
            return { ...this.$data };
        },
        resetData() {
            // 用 Object.assign 替换 this 上的数据为初始状态
            Object.assign(this.$data, this.$options.data.call(this));
        },
        // 删除图片
        handleRemove(item, index) {
            item.imageList.splice(index, 1)
        },
        // 已选图片
        Selected_pictures(item) {
            this.isShowVariantImg = true
            this.variantImages = item.imageList
        },
        isObject(val) {
            return typeof val === 'object' && val !== null && !Array.isArray(val);
        },

        isArray(val) {
            return Array.isArray(val);
        },

        shopDiscount(value, index) {
            this.$nextTick(() => {
                this.shopIndex = index
                this.discount = value.row
                this.editIndex = value.$index;
                if (index == 1) {
                    this.shopTitle = "可购买优惠编辑";
                    const purchasable_offer = this.setPurchasable_offer( JSON.parse(sessionStorage.getItem('purchasable_offer')));
                    const data1 = value.row.purchasable_offer_data ? value.row.purchasable_offer_data[0] : {};
                    const fun = (value, object) => {
                        if(!object.children || object.children.length == 0){
                            return
                        }
                        for(let i = 0; i < object.children.length; i++){
                            if(this.isArray(value[object.children[i].property])){
                                fun(value[object.children[i].property][0], object.children[i])
                            }else if(this.isObject(value[object.children[i].property])){
                                fun(value[object.children[i].property], object.children[i])
                            }else{
                                object.children[i].value = value[object.children[i].property]
                            }
                        }
                    }
                    fun(data1, purchasable_offer)
                    this.$set(value.row, 'purchasable_offer', purchasable_offer)
                    this.purchasable_offer = purchasable_offer;
                    this.dialogShopVisible = true
                } else if (index == 2) {
                    this.shopTitle = "履行可用性编辑";
                    this.fulfillment_availability_data = value.row.fulfillment_availability ? value.row.fulfillment_availability : {};
                    this.dialogShopVisible = true
                } else {
                    this.shopTitle = "标价编辑";
                    this.list_price_data = value.row.list_price ? value.row.list_price : {};
                    this.dialogShopVisible = true
                }
            })
        },
        setPurchasable_offer(schema) {
            // 遍历当前层级的所有字段
            schema.children.forEach(child => {
                // 递归处理子字段
                if (child.children && child.children.length > 0) {
                    this.setPurchasable_offer(child);  // 对于有 children 的字段进行递归
                } else {
                    // 根据类型生成对应的值
                    // 确保在DOM更新后执行
                    if (child.enumValue != null) {
                        child.enumValue = JSON.parse(child.enumValue);
                    }
                    if (child.oneOf != null) {
                        child.oneOf = JSON.parse(child.oneOf);
                        child.oneOfValue = child.oneOf[0].format;
                    }
                }
            });
            return schema
        },
        generateJsonData(schema) {
            if (!schema || !schema.children || schema.children.length === 0) {
                return null;
            }
            const data = {};
            schema.children.forEach(child => {
                const key = child.property;
                if (['audience', 'currency'].includes(key)) {
                    if (child.value) {
                        data[key] = child.value;
                    }
                }
                // 处理子字段
                else if (child.children && Array.isArray(child.children) && child.children.length > 0) {
                    const childData = this.generateJsonData(child);
                    if (childData) {
                        if (child.type === 'array') {
                            data[key] = [childData];
                        } else {
                            data[key] = childData;
                        }
                    }
                }
                else {
                    let value = child.value;
                    // 类型转换
                    switch (child.type) {
                        case 'string':
                            value = value ? value.toString() : null;
                            break;
                        case 'integer':
                            value = value ? parseInt(value, 10) : null;
                            break;
                        case 'number':
                            value = value ? parseFloat(value) : null;
                            break;
                        case 'boolean':
                            value = value === 'true';
                            break;
                        case 'array':
                            value = value ? JSON.parse(value) : [];
                            break;
                        default:
                            if (child.property === "marketplace_id") {
                                value = this.$parent.$parent.publishInfo.row.marketplaceId;
                            }
                            break;
                    }
                    if (['start_at', 'end_at'].includes(key) && value) {
                        data[key] = value;
                    }
                    else if (value !== null && value !== undefined &&
                        (!Array.isArray(value) || value.length > 0) &&
                        (typeof value !== 'object' || Object.keys(value).length > 0)) {
                        data[key] = value;
                    }
                }
            });
            return Object.keys(data).length > 0 ? data : null;
        },
        setAttributes(a, b, c) {
            let locators = null;
            let childrenLocators = null;
            let obj = {}
            let isTrue = false
            for (let index = 0; index < a.length; index++) {
                locators = b[index].name
                isTrue = false
                if (locators == c) {
                    for (let p = 0; p < b[index].children.length; p++) {
                        childrenLocators = b[index].children[p]
                        if (childrenLocators.property == 'language_tag') {
                            obj[childrenLocators.property] = this.$parent.$parent.locale
                        } else if (childrenLocators.property == 'marketplace_id') {
                            obj[childrenLocators.property] = this.$parent.$parent.publishInfo.row.marketplaceId
                        } else {
                            if (b[index].children[p].publishProduct == '' || b[index].children[p].publishProduct == undefined || b[index].children[p].publishProduct == 'undefined') {
                                isTrue = true
                                if (b[index].children[p].publishProduct === true || b[index].children[p].publishProduct === false) {
                                    obj[childrenLocators.property] = this.convertValue(b[index].children[p].publishProduct, childrenLocators.type)
                                    isTrue = false
                                }
                            } else {
                                obj[childrenLocators.property] = this.convertValue(b[index].children[p].publishProduct, childrenLocators.type)
                            }
                        }
                    }
                    if (locators == 'fulfillment_availability') {
                        isTrue = false
                    }
                    if (isTrue != true) {
                        return [{ ...obj }]
                    }
                }
            }
        },
        echoDataOffer(a, b, c, d) {
            this.list_priceNum = []
            let locators = null;
            let positionText = null;
            // for (let index = 0; index < c.length; index++) {
            //     locators = c[index].name
            //     if (locators == d) {
            //         for (let i = 0; i < b[index].length; i++) {
            //             positionText = b[index][i].property
            //             this.list_priceNum.push(a[locators][0][positionText])
            //         }
            //     }
            // }
            console.log(a);
            sessionStorage.setItem('list_priceNum', JSON.stringify(this.list_priceNum))
        },
        echoData(a, b, c, d) {
            let locators = null;
            let positionText = null;
            for (let index = 0; index < c.length; index++) {
                locators = c[index].name
                if (locators == d) {
                    for (let i = 0; i < b[index].length; i++) {
                        positionText = b[index][i].property
                        b[index][i].publishProduct = a[locators][0][positionText]
                    }
                }
            }
        },
        // 转换类型
        convertValue(value, type) {
            switch (type) {
                case 'string':
                    return String(value);
                case 'boolean':
                    if (value == 'true' || value == true) {
                        return true;
                    } else if (value == 'false' || value == false) {
                        return false;
                    }
                    return Boolean(value);
                case 'integer':
                    return parseInt(value, 10);
                case 'number':
                    return parseFloat(value);
                default:
                    return value;
            }
        },
        offerLice(schema, parent = null) {
            // 遍历当前层级的所有字段
            schema.children.forEach((child, index) => {
                // 获取当前节点的上一个节点
                const prevChild = schema.children[index - 1]; 
                // 递归处理子字段
                if (child.children && child.children.length > 0) {
                    // 递归调用时传递当前节点作为parent
                    this.offerLice(child, schema);  // 对于有 children 的字段进行递归
                } else {
                    if (!child.children || child.children.length === 0) {
                        const listPriceNum = JSON.parse(sessionStorage.getItem('list_priceNum'));
                        if ((parent && parent.property === "our_price") || child.title === "value_with_tax") {
                            if (child.value === '' || child.value === ' ' || child.value === null || child.value === undefined) {
                                if (typeof listPriceNum[1] === 'number') {
                                    this.$set(child, 'value', listPriceNum[1]);
                                } else {
                                    this.$set(child, 'value', listPriceNum[0]);
                                }
                            }
                        }
                        if (child.titleChinese === "货币") {
                            if (child.value === '' || child.value === ' ' || child.value === null || child.value === undefined) {
                                if (typeof listPriceNum[0] === 'string') {
                                    this.$set(child, 'value', listPriceNum[0]);
                                } else {
                                    this.$set(child, 'value', listPriceNum[1]);
                                }
                            }
                        }
                    }
                }
            });
            return schema;
        },
        // 可购买优惠默认带入标价
        offerInfo() {
            for (let index = 0; index < this.tableList.length; index++) {
                this.echoDataOffer(this.tableList[index], this.oneTopShuxingArr, this.topShuxingArr, 'list_price')
                this.tableList[index].purchasable_offer = [this.generateJsonData(this.offerLice(JSON.parse(sessionStorage.getItem('purchasable_offer'))))];
                this.tableList[index].oldPurchasable_offer = this.offerLice(JSON.parse(sessionStorage.getItem('purchasable_offer')))
            }
        },
        validateFieldsBySchema(dataObj , rulesString, fieldNames = []) {
            console.log(dataObj , rulesString, fieldNames);
            // 提取所有与字段名相关的规则
            const relatedRules = rulesString.filter(rule =>
                fieldNames.some(field => JSON.stringify(rule).includes(field))
            );
            console.log(JSON.parse(JSON.stringify(relatedRules)));

            // 构建一个 schema，只包含指定字段
            const schema = {
                type: "object",
                properties: {},
                allOf: relatedRules
            };
            console.log(1);

            const validate = ajv.compile(schema);
            const valid = validate(dataObj);

            if (valid) {
                return { valid: true, errors: [] };
            }

            const missingFields = [];
            const invalidFields = {};
            for (const err of validate.errors) {
                if (err.keyword === "required") {
                const field = err.params.missingProperty;
                const path = err.instancePath ? `${err.instancePath.replace(/^\//, "").replace(/\//g, ".")}.${field}` : field;
                missingFields.push(path);
                } else {
                const path = err.instancePath.replace(/^\//, "").replace(/\//g, ".");
                invalidFields[path] = err.message;
                }
            }

            return {
                valid: false,
                missingFields: [...new Set(missingFields)],
                invalidFields
            };
        },
        // 校验某一行填的数据是否规范或者必填
        validateRowData(rowData, type = 'outer', validateKey = null){
            return new Promise((resolve, reject)=>{
                // const obj = {};
                
                // const arrs = [];
                // if(validateKey === null || validateKey === 'purchasable_offer'){
                //     obj.purchasable_offer = rowData.purchasable_offer_data;
                //     arrs.push('purchasable_offer');
                // }
                // if(validateKey === null || validateKey === 'fulfillment_availability'){
                //     obj.fulfillment_availability = [rowData.fulfillment_availability];
                //     arrs.push('fulfillment_availability');
                // }
                // if(validateKey === null || validateKey === 'list_price'){
                //     obj.list_price = [rowData.list_price];
                //     arrs.push('list_price');
                // }
                
                // const missing = this.validateFieldsBySchema(obj, this.allOf, arrs)
                // console.log(missing);
                // return
                const allError = [];
                if(validateKey === null || validateKey === 'purchasable_offer'){ //暂时不验证purchasable_offer
                    // let purchasable_offer = {};
                    // if(type == 'outer'){
                    //     purchasable_offer = this.setPurchasable_offer( JSON.parse(sessionStorage.getItem('purchasable_offer')));
                    //     const data1 = rowData.purchasable_offer_data ? rowData.purchasable_offer_data[0] : {};
                    //     const data = JSON.parse(JSON.stringify(data1));
                    //     const fun = (value, object) => {
                    //         if(!object.children || object.children.length == 0){
                    //             return
                    //         }
                    //         for(let i = 0; i < object.children.length; i++){
                    //             if(this.isArray(value[object.children[i].property])){
                    //                 fun(value[object.children[i].property][0], object.children[i])
                    //             }else if(this.isObject(value[object.children[i].property])){
                    //                 fun(value[object.children[i].property], object.children[i])
                    //             }else{
                    //                 object.children[i].value = value[object.children[i].property]
                    //             }
                    //         }
                    //     }
                    //     fun(data, purchasable_offer);
                    // }else{
                    //     purchasable_offer = rowData.purchasable_offer;
                    // }
                    // function getLeafNodesWithPath(data, parentTitles = []) {
                    //     const results = [];

                    //     const currentTitle = data.titleChinese || null;
                    //     const currentPath = currentTitle ? [...parentTitles, currentTitle] : parentTitles;

                    //     if (!data.children || data.children.length === 0) {
                    //         results.push({
                    //             titlePath: currentPath.join(' > '),
                    //             ...data,
                    //         });
                    //     } else {
                    //         for (const child of data.children) {
                    //             results.push(...getLeafNodesWithPath(child, currentPath));
                    //         }
                    //     }
                    //     return results;
                    // }
                    // const result = getLeafNodesWithPath(purchasable_offer);
                    // const bitianArr = [];
                    // const numberArr = [];
                    // for(let i = 0; i < result.length; i++){
                    //     if(result[i].required === 1){
                    //         if(result[i].value === '' || result[i].value === ' ' || result[i].value === null || result[i].value === undefined){
                    //             bitianArr.push(result[i].titleChinese);
                    //         }
                    //     }
                    //     if(result[i]['type'] === 'number'){
                    //         if(isNaN(result[i].value) && result[i].value){
                    //             numberArr.push(result[i].titleChinese);
                    //         }
                    //     }
                    // }
                    // const errorArr = [];
                    // if(bitianArr.length > 0){
                    //     errorArr.push(bitianArr.join('，') + '必填')
                    // }
                    // if(numberArr.length > 0){
                    //     errorArr.push(numberArr.join('，') + '请输入数字')
                    // }
                    // if(errorArr.length > 0){
                    //     allError.push((validateKey ? '' : '可购买优惠：') + errorArr.join('，'))
                    // }
                }
                if(validateKey === 'fulfillment_availability' || validateKey === null){
                    const rule = this.typeInfo.find(item => item.property === 'fulfillment_availability');
                    let data1 = rowData.fulfillment_availability || {};
                    const bitianArr = [];
                    const numberArr = [];
                    const zhengsuArr = [];
                    for(let i = 0; i < rule.children.length; i++){
                        if(rule.children[i].required === 1){
                            if(data1[rule.children[i].property] === '' || data1[rule.children[i].property] === ' ' || data1[rule.children[i].property] === null || data1[rule.children[i].property] === undefined){
                                bitianArr.push(rule.children[i].titleChinese);
                            }
                        }
                        if(rule.children[i]['type'] === 'number' || rule.children[i]['type'] === 'integer'){
                            if(isNaN(data1[rule.children[i].property]) && data1[rule.children[i].property]){
                                numberArr.push(rule.children[i].titleChinese);
                            }
                        }
                        if(rule.children[i]['type'] === 'integer'){
                            try{
                                if(!Number.isInteger(+(data1[rule.children[i].property])) && data1[rule.children[i].property]){
                                    zhengsuArr.push(rule.children[i].titleChinese);
                                }
                            }catch(e){
                                zhengsuArr.push(rule.children[i].titleChinese);
                            }
                        }
                    }
                    const errorArr = [];
                    if(bitianArr.length > 0){
                        errorArr.push(bitianArr.join('，') + '必填')
                    }
                    if(numberArr.length > 0){
                        errorArr.push(numberArr.join('，') + '请输入数字')
                    }
                    if(zhengsuArr.length > 0){
                        errorArr.push(zhengsuArr.join('，') + '请输入整数')
                    }
                    if(errorArr.length > 0){
                        allError.push((validateKey ? '' : '履行可用性：') + errorArr.join('，'))
                    }
                }
                if(validateKey === 'list_price' || validateKey === null){
                    const rule = this.typeInfo.find(item => item.property === 'list_price');
                    let data1 = rowData.list_price || {};
                    const bitianArr = [];
                    const numberArr = [];
                    const zhengsuArr = [];
                    for(let i = 0; i < rule.children.length; i++){
                        if(rule.children[i].required === 1){
                            if(data1[rule.children[i].property] === '' || data1[rule.children[i].property] === ' ' || data1[rule.children[i].property] === null || data1[rule.children[i].property] === undefined){
                                bitianArr.push(rule.children[i].titleChinese);
                            }
                        }
                        if(rule.children[i]['type'] === 'number'){
                            if(isNaN(data1[rule.children[i].property]) && data1[rule.children[i].property]){
                                numberArr.push(rule.children[i].titleChinese);
                            }
                        }
                        if(rule.children[i]['type'] === 'integer'){
                            try{
                                if(!Number.isInteger(+data1[rule.children[i].property]) && data1[rule.children[i].property]){
                                    zhengsuArr.push(rule.children[i].titleChinese);
                                }
                            }catch(e){
                                zhengsuArr.push(rule.children[i].titleChinese);
                            }
                        }
                    }
                    const errorArr = [];
                    if(bitianArr.length > 0){
                        errorArr.push(bitianArr.join('，') + '必填')
                    }
                    if(numberArr.length > 0){
                        errorArr.push(numberArr.join('，') + '请输入数字')
                    }
                    if(zhengsuArr.length > 0){
                        errorArr.push(zhengsuArr.join('，') + '请输入整数')
                    }
                    if(errorArr.length > 0){
                        allError.push((validateKey ? '' : '标价：') + errorArr.join('，'))
                    }
                }
                if(allError.length > 0){
                    reject({
                        msg: allError.join('。'),
                        state: false
                    });
                }
                resolve({
                    state: true,
                });
            })
        },
        setShopDiscount() {
            this.$nextTick(async () => {
                let jsonData = null;
                let object = null;
                let oldPurchasable_offerJson = null;
                if (this.shopIndex == 1) {
                    this.$set(this.tableList[this.editIndex], 'purchasable_offer_data', [this.generateJsonData(this.tableList[this.editIndex].purchasable_offer)])
                    // try {
                    //     await this.validateRowData(this.tableList[this.editIndex], 'inner', 'purchasable_offer');
                    // } catch (error) {
                    //     this.$message.error(error.msg);
                    //     return
                    // }
                    

                    jsonData = [this.generateJsonData(this.purchasable_offer)]; //设置相同的变体购买优惠
                    oldPurchasable_offerJson = JSON.parse(JSON.stringify(this.purchasable_offer));
                    // 给本次修改的内容赋值
                    
                    if (this.harderValue === 1) {
                        object = this.discount.COLOR;
                        for (let index = 0; index < this.tableList.length; index++) {
                            if (object == this.tableList[index].COLOR) {
                                this.$set(this.tableList[index], 'purchasable_offer_data', JSON.parse(JSON.stringify(jsonData)));
                                this.tableList[index].oldPurchasable_offer = JSON.parse(JSON.stringify(oldPurchasable_offerJson));
                            }
                        }
                    }
                    if (this.harderValue === 2) {
                        object = this.discount.SIZE;
                        for (let index = 0; index < this.tableList.length; index++) {
                            if (object == this.tableList[index].SIZE) {
                                this.$set(this.tableList[index], 'purchasable_offer_data', JSON.parse(JSON.stringify(jsonData)));
                                this.tableList[index].oldPurchasable_offer = JSON.parse(JSON.stringify(oldPurchasable_offerJson));
                            }
                        }
                    }
                    if (this.harderValue === 3) {
                        for (let index = 0; index < this.tableList.length; index++) {
                            this.$set(this.tableList[index], 'purchasable_offer_data', JSON.parse(JSON.stringify(jsonData)));
                            this.tableList[index].oldPurchasable_offer = JSON.parse(JSON.stringify(oldPurchasable_offerJson));
                        }
                    }
                    // if (this.harderValue === null) {
                    //     for (let index = 0; index < this.tableList.length; index++) {
                    //         if (this.discount.SKU == this.tableList[index].SKU) {
                    //             this.$set(this.tableList[index], 'purchasable_offer_data', JSON.parse(JSON.stringify(jsonData)));
                    //             this.tableList[index].oldPurchasable_offer = JSON.parse(JSON.stringify(oldPurchasable_offerJson));
                    //         }
                    //     }
                    // }
                } else {

                    let key = '';
                    if(this.shopIndex == 2){
                        key = 'fulfillment_availability';
                        jsonData = this.fulfillment_availability_data;;
                    }else if(this.shopIndex == 3){
                        key = 'list_price';
                        jsonData = this.list_price_data;
                    }
                    this.tableList[this.editIndex][key] = jsonData;
                    try {
                        await this.validateRowData(this.tableList[this.editIndex], 'inner', key);
                    } catch (error) {
                        this.$message.error(error.msg);
                        return
                    }
                    
                    
                    if (this.harderValue == 1) {
                        object = this.discount.COLOR
                        for (let index = 0; index < this.tableList.length; index++) {
                            if (object == this.tableList[index].COLOR) {
                                this.$set(this.tableList[index], key, jsonData)
                            }
                        }
                    } else if (this.harderValue == 2) {
                        object = this.discount.SIZE
                        for (let index = 0; index < this.tableList.length; index++) {
                            if (object == this.tableList[index].SIZE) {
                                this.$set(this.tableList[index], key, jsonData)
                            }
                        }
                    } else if (this.harderValue == 3) {
                        for (let index = 0; index < this.tableList.length; index++) {
                            this.$set(this.tableList[index], key, jsonData)
                        }
                    } else {
                        this.discount[key] = jsonData
                    }
                }
                this.harderValue = null
                this.dialogShopVisible = false;
                this.editIndex = -1;
            })
        },
        clickBianHao() {
            let parmamsData = {
                companyId: JSON.parse(localStorage.getItem("role")).company_id,
                count: this.tableList.length
            }
            let API = Baseurl + 'amazonEan/getUsableEan'
            ajaxPost(API, parmamsData)
                .then((res) => {
                    if (res.data.code == 200) {
                        for (let index = 0; index < this.tableList.length; index++) {
                            this.tableList[index].shopId = res.data.data[index]
                        }
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message,
                        })
                    }
                })
                .catch((e) => {
                    console.log(e)
                })
        },
        numberInput(items) {
            if (items.maximum != null) {
                if (parseFloat(items.publishProduct) > items.maximum) {
                    items.publishProduct = items.maximum
                }
            }
            console.log(items);

        },
        productInput(items) {
            this.numberInput(items);
            if(items.publishProduct){
                this.$set(items, 'publishProduct', +items.publishProduct);
            }
        },
        listPriceInput(items) {
            this.numberInput(items);
            if(this.list_price_data[items.property]){
                this.$set(this.list_price_data, items.property, +this.list_price_data[items.property]);
            }
        },
        fulfillAvailabilityInput(items){
            this.numberInput(items);
            if(this.fulfillment_availability_data[items.property]){
                this.$set(this.fulfillment_availability_data, items.property, +this.fulfillment_availability_data[items.property]);
            }
        },
        onConfirmByXuanzeImg(img) {
            var locator = null
            this.tableList[this.selectImageIndex].imageList = []
            for (let index = 0; index < img.length; index++) {
                locator = this.$parent.$parent.$refs.images.imageList[index]
                this.tableList[this.selectImageIndex].imageList.push({
                    name: locator,
                    url: img[index]
                })
            }
        },
        selectOnePicture(scope) {
            this.selectImageIndex = scope.$index;
            this.activeImg = scope.row.imageList.map(item => item.url);
            this.xuanzeShow = true
        },
        // 选择颜色和尺寸
        putText(item) {
            let en_value = item.split('-')[1] ? item.split('-')[1].trim() : item
            let variantTextArray = []
            if (this.variantText) {
                variantTextArray = this.variantText.split(',')
            }
            if (variantTextArray.some((item) => item === en_value)) {
                this.$message.error('已选择此项')
                return false
            }
            variantTextArray.push(en_value)
            this.variantText = variantTextArray.join(',')
        },
        // 变体预设
        variantPreset(value) {
            if (value.toLowerCase() == 'color' || value.toLowerCase() == 'color_name') {
                this.recommendSpecs = colorList.colorList
                this.dialogVariantVisible = true
            } else if (value.toLowerCase() == 'size' || value.toLowerCase() == 'size_name') {
                this.recommendSpecs = sizeList.sizeList
                this.dialogVariantVisible = true
            }
            for (let index = 0; index < this.variantTitle.length; index++) {
                if (value == this.variantTitle[index]) {
                    this.variantText = this.shuRuVariant[index]
                    this.variantPresetIndex = index
                }
            }
        },
        saveVariantInfoEdit1() {
            if (!this.variantText) return
            this.shuRuVariant[this.variantPresetIndex] = this.variantText
            this.dialogVariantVisible = false
        },
        // 选项切换
        variantChange(value) {
            this.tableList = [];
            this.dialogShopVisible = false;
            this.$nextTick(() => {
                if (value == 'one') {                    
                    if (this.offerJson != null) {
                        this.purchasable_offer = this.offerJson[0]
                    }
                    if(!this.purchasable_offer){
                        this.purchasable_offer = this.setPurchasable_offer(JSON.parse(sessionStorage.getItem('purchasable_offer')));
                    }
                }
                if (value == 'two') {
                    if(this.aiPower && (this.aiPower + '').split(',').includes('1')){
                        this.setTargetCountry();
                    }
                    if (this.variantInfo) {
                        this.variantTitle = []
                        if (this.variantInfo[0].attributes.variation_theme[0].name.indexOf('/')) {
                            this.formData.bianti = this.variantInfo[0].attributes.variation_theme[0].name
                            this.variantTitle = this.variantInfo[0].attributes.variation_theme[0].name.split('/'); //变体主题

                            let locator = null;
                            let arr = []
                            for (let index = 0; index < this.variantTitle.length; index++) {
                                arr = []
                                locator = this.variantTitle[index].toLowerCase()
                                for (let i = 0; i < this.variantInfo.length; i++) {
                                    if (this.variantInfo[i].attributes[locator]) {
                                        arr.push(this.variantInfo[i].attributes[locator][0].value)
                                        let newArr = arr.filter((item, index) => {
                                            return arr.indexOf(item) === index
                                        })
                                        this.shuRuVariant[index] = newArr.join(',')
                                    }
                                }
                            }
                            const result = [];
                            for (let index = 0; index < this.variantInfo.length; index++) {
                                const imgArr = []
                                for (let i = 0; i < this.$parent.$parent.$refs.images.imageList.length; i++) {
                                    locator = this.$parent.$parent.$refs.images.imageList[i]
                                    if (this.variantInfo[index].attributes[locator] != undefined) {
                                        imgArr.push({
                                            name: locator,
                                            url: this.variantInfo[index].attributes[locator][0].media_location || ''
                                        })
                                    }
                                }
                                const item = {
                                    SKU: this.variantInfo[index].sku,
                                    imageList: imgArr,
                                    purchasable_offer_data: this.variantInfo[index].attributes.purchasable_offer,
                                    fulfillment_availability: this.variantInfo[index].attributes.fulfillment_availability ? this.variantInfo[index].attributes.fulfillment_availability[0] : {},
                                    list_price: this.variantInfo[index].attributes.list_price ? this.variantInfo[index].attributes.list_price[0] : {}
                                }
                                
                                if (this.variantInfo[index].attributes.externally_assigned_product_identifier != undefined) {
                                    item.shopType = this.variantInfo[index].attributes.externally_assigned_product_identifier[0].type;
                                    item.shopId = this.variantInfo[index].attributes.externally_assigned_product_identifier[0].value;
                                    item.numberItem = this.variantInfo[index].attributes.number_of_items[0].value || 1;
                                }
                                const skuArr = [];
                                for (let j = 0; j < this.variantTitle.length; j++) {
                                    const locator = this.variantTitle[j].toLowerCase()
                                    if (this.variantInfo[index].attributes[locator]) {
                                        arr.push(this.variantInfo[index].attributes[locator][0].value)
                                        item[this.variantTitle[j]] = this.variantInfo[index].attributes[locator][0].value;
                                        skuArr.push(item[this.variantTitle[j]]);
                                    }
                                }
                                if(this.formData.Sku === item.SKU){
                                    item.SKU = item.SKU + '-' + skuArr.join('-');
                                }
                                result.push(item)
                            }
                            this.tableList = result;
                        } else {
                            this.formData.bianti = this.variantInfo[0].attributes.variation_theme[0].name
                            this.variantTitle.push(this.variantInfo[0].attributes.variation_theme[0].name)
                        }
                    }
                }
            })
        },
        // 验证数据
        async validateData(){
            const skuObj = {};
            let state = true;
            const repeatSku = [];
            const allPro = [];
            const skuRows = [];
            const cplxRows = [];
            const cpbhRows = [];
            for(let i = 0; i < this.tableList.length; i++){
                if(!skuObj[this.tableList[i].SKU]){
                    skuObj[this.tableList[i].SKU] = 1;
                }else{
                    if(!repeatSku.includes(this.tableList[i].SKU)){
                        repeatSku.push(this.tableList[i].SKU);
                    }
                }
                if(this.$refs['numberItemRef' + i]){
                    const pro =this.$refs['numberItemRef' + i].validate();
                    allPro.push(pro);
                }
                if(!this.tableList[i].SKU){
                    skuRows.push(i + 1);
                }
                if(!this.tableList[i].shopType){
                    cplxRows.push(i + 1);
                }
                if(!this.tableList[i].shopId){
                    cpbhRows.push(i + 1);
                }
            }
            if(skuRows.length > 0){
                this.$message.error('第' + skuRows.join('，') + '行SKU必填');
                return false;
            }
            if(cplxRows.length > 0){
                this.$message.error('第' + cplxRows.join('，') + '行外部产品类型必填');
                return false;
            }
            if(cpbhRows.length > 0){
                this.$message.error('第' + cpbhRows.join('，') + '行外部产品编号必填');
                return false;
            }
            if(repeatSku.length > 0){
                this.$message.error('SKU' + repeatSku.join('，') + '重复');
                return false;
            }
            try {
                const res = await Promise.all(allPro);
                return state;
            } catch (error) {
                this.$message.error(error);
                return false;
            }
            
        },
        // 添加变量按钮
        addVariant() {
            for(let i = 0; i < this.shuRuVariant.length; i++){
                const arr = this.shuRuVariant[i].split(',');
                this.$set(this.shuRuVariant, i, [...new Set(arr)].join(','))
            }
            if(!this.formData.bianti){
                this.$message.error('请选择变体主题');
                return;
            }
            if(this.shuRuVariant.some(item => item == '')){
                this.$message.error('请输入变体属性');
                return;
            }
            this.saveVariantInfoEdit()
        },
        handleFocus() { },
        // 处理数据
        getvariantTag() {
            let listVariant = []
            for (let index = 0; index < this.shuRuVariant.length; index++) {
                listVariant[this.variantTitle[index]] = this.shuRuVariant[index].split(',')
            }
            const varinatData = []
            for (const item in listVariant) {
                if (listVariant[item].length) {
                    varinatData.push(listVariant[item])
                }
            }
            if (!varinatData.length) return []
            return varinatData.reduce((a, b) =>
                a
                    .map((aItem) => b.map((bItem) => `${aItem}&-;${bItem}`))
                    .reduce((a, b) => [...a, ...b])
            )
        },
        saveVariantInfoEdit() {
            this.tableList = []
            const variantTags = this.getvariantTag()
            // 根据组合好的变体标识生成表单数据
            let arr = []
            const tableData = variantTags.map((item) => {
                this.tableListPush(item.split('&-;'))
            })
        },
        tableListPush(value) {
            let itemObj = {
                SKU: '',//sku编号
                shopType: '',//商品编码类型
                shopId: '',//商品编码
                imageList: [],
                purchasable_offer: this.setPurchasable_offer( JSON.parse(sessionStorage.getItem('purchasable_offer'))),
                purchasable_offer_data: [{}],
            }
            if (value.length == 1) {
                itemObj[this.variantTitle[0]] = value[0]
            } else if (value.length == 2) {
                itemObj[this.variantTitle[0]] = value[0]
                itemObj[this.variantTitle[1]] = value[1]
            } else if (value.length == 3) {
                itemObj[this.variantTitle[0]] = value[0]
                itemObj[this.variantTitle[1]] = value[1]
                itemObj[this.variantTitle[2]] = value[2]
            } else if (value.length == 4) {
                itemObj[this.variantTitle[0]] = value[0]
                itemObj[this.variantTitle[1]] = value[1]
                itemObj[this.variantTitle[2]] = value[2]
                itemObj[this.variantTitle[3]] = value[3]
            }
            const skuArr = [];
            for(let i = 0; i < this.variantTitle.length; i++){
                skuArr.push(itemObj[this.variantTitle[i]])
            }
            itemObj.SKU = this.formData.Sku + '-' + skuArr.join('-')
            // for (let index = 0; index < this.$parent.$parent.$refs.info.product_identity.length; index++) {
            //     if (this.$parent.$parent.$refs.info.product_identity[index].name == 'externally_assigned_product_identifier') {
            //         for (let i = 0; i < this.$parent.$parent.$refs.info.product_identity[index].children.length; i++) {
            //             if (this.$parent.$parent.$refs.info.product_identity[index].children[i].property == 'type') {
            //                 itemObj.shopType = this.$parent.$parent.$refs.info.product_identity[index].children[i].publishProduct
            //             }
            //         }
            //     }
            // }
            this.tableList.push(itemObj)
        },
        // 选择变体主题
        selectVariantTitle(value) {
            let arr = value.split('/')
            this.variantTitle = arr
            this.shuRuVariant = []
            this.tableList = []
            for (let index = 0; index < this.variantTitle.length; index++) {
                this.shuRuVariant.push('')
            }
        },
        // 批量删除处理
        on_batch_select(val) {
            this.batch_select = val
        },
        // 移除某行
        removeItem(scope) {
            this.tableList.splice(scope.$index, 1)
            this.isYichu = true
        },
        // 添加一行
        addItem() {
            let itemObj = {
                SKU: '',//sku编号
                shopType: '',//商品编码类型
                shopId: '',//商品编码
                imageList: null
            }
            this.tableList.push(itemObj)
        },
        // 批量删除
        removeAll() {
            if (this.batch_select.length == 0) {
                return this.$alert('请至少勾选一项变体属性！', '提示', {
                    confirmButtonText: '确定',
                })
            }
            if (this.batch_select.length == this.tableList.length) {
                return this.$alert('请至少保留一项变体属性！', '提示', {
                    confirmButtonText: '确定',
                })
            }
            //存放移除的下标
            let arrList = []
            this.tableList = JSON.parse(JSON.stringify(this.tableList.filter((item, index) => {
                //相等说明对象
                let ss = this.batch_select.some(itemSome => {
                    return item == itemSome
                })
                if (ss) {
                    arrList.push(index)
                }
                return !ss
            }))),
                this.batch_select = []
            this.isYichu = true
        }
    },
};
</script>
<style lang="scss" scoped>
@import "../../../AllegroProductAllegro/ozon.less";

.shuxing_box {
    min-height: 100px;
    background: rgb(238, 238, 238);
    border-radius: 10px;
    width: 88%;
    float: left;
    padding: 10px 0;
    font-size: 16px;

    .item_shuxing {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 4px;

        .shuxing_label {
            width: 20%;
            text-align: right;
            padding: 3px 10px;

            .shuxing_label_bitian {
                color: red;
                margin-right: 4px;
            }
        }

        .shuxing_input {
            width: 100%;
            padding: 5px 0px;
        }

        .shuxing_select {
            width: 100%;
        }

        .shuxing_button {
            width: 30px;
            height: 30px;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgb(255, 183, 82);
            color: white;
            font-weight: 700;
            font-size: 20px;
            margin-left: 10px;
        }
    }
}

.shuxing_box2 {
    min-height: 100px;
    background: rgb(238, 238, 238);
    border-radius: 10px;
    width: 190%;
    float: left;
    padding: 10px 0;
    font-size: 16px;

    .item_shuxing {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 4px;

        .shuxing_label {
            width: 20%;
            text-align: right;
            padding: 3px 10px;

            .shuxing_label_bitian {
                color: red;
                margin-right: 4px;
            }
        }

        .shuxing_input {
            width: 100%;
            padding: 5px 0px;
        }

        .shuxing_select {
            width: 100%;
        }

        .shuxing_button {
            width: 30px;
            height: 30px;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgb(255, 183, 82);
            color: white;
            font-weight: 700;
            font-size: 20px;
            margin-left: 10px;
        }
    }
}

.search_box {
    padding: 15px 10px;
    width: calc(100% - 20px);
    background: rgb(238, 238, 238);
    margin-top: 10px;
    display: flex;

    .search_box_item {
        width: 30%;
        margin-right: 20px;

        .leimu_box {
            height: 400px;
            padding: 10px;
            overflow-y: auto;
            background: white;

            .leimu_item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                cursor: pointer;
                padding: 5px 0;
                font-size: 16px;

                .leimu_item_desc {
                    width: calc(100% - 20px);
                    white-space: nowrap;
                    /* 确保文本在一行内显示 */
                    overflow: hidden;
                    /* 隐藏溢出的内容 */
                    text-overflow: ellipsis;
                }

                .item_leimu_you {
                    color: rgb(82, 190, 166);
                    margin-top: 3px;
                }
            }

            .select_leimu {
                border: 1px solid rgb(82, 190, 166);
                box-sizing: content-box;
            }

            .leimu_item:hover {
                border: 1px solid rgb(82, 190, 166);
                color: rgb(82, 190, 166);
                box-sizing: content-box;
            }
        }
    }
}

.search_box2 {
    padding: 15px 0px 15px 2px;
    width: calc(100%);
    background: rgb(238, 238, 238);
    margin-top: 10px;
}

.leimu_box2 {
    height: 400px;
    padding: 10px;
    overflow-y: auto;
    background: white;
    width: calc(100% - 20px);

    .leimu_item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: 7px 0;
        font-size: 14px;

        .leimu_item_desc {
            width: calc(100% - 20px);
            white-space: nowrap;
            /* 确保文本在一行内显示 */
            overflow: hidden;
            /* 隐藏溢出的内容 */
            text-overflow: ellipsis;
        }

        .item_leimu_you {
            color: rgb(82, 190, 166);
            margin-top: 3px;
        }
    }

    .select_leimu {
        border: 1px solid rgb(82, 190, 166);
        box-sizing: content-box;
    }

    .leimu_item:hover {
        border: 1px solid rgb(82, 190, 166);
        color: rgb(82, 190, 166);
        box-sizing: content-box;
    }
}

.item_img {
    height: 16px;
    width: 16px;
    margin-left: 5px;
    cursor: pointer;
}

.el_tip_box {
    width: 360px;
    font-size: 16px;
    background: rgb(39, 39, 39);
    border-radius: 10px;
    padding: 8px;
    color: whitesmoke;
}

.shuxing_button {
    width: 30px;
    height: 30px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(255, 183, 82);
    color: white;
    font-weight: 700;
    font-size: 20px;
    margin-left: 10px;
}


::v-deep .el-upload__text {
    display: flex;
    flex-direction: column;
    color: #606266;
    font-size: 14px;
    position: absolute;
    top: 30px;
    width: 100%;
    height: 100%;

    em {
        margin-top: -90%;
    }
}

::v-deep .el-upload el-upload--picture-card {
    width: 110px;
    height: 110px;
}

::v-deep .el-upload-dragger {
    width: 100%;
    height: 100%;
    border: none;
    position: relative;
}

.el_tip_box {
    width: 360px;
    font-size: 18px;
    background: rgb(39, 39, 39);
    border-radius: 10px;
    padding: 15px;
    color: whitesmoke;
}

.item_img {
    height: 16px;
    width: 16px;
    margin-left: 5px;
    cursor: pointer;
}

.image_input {
    position: relative;
}

.item_img_ipput {
    position: absolute;
    right: 5px;
    top: 6px;
    height: 20px;
    width: 20px;
    cursor: pointer;
}

.Minister-top {
    width: 99%;
    border-radius: 4px;
    overflow: hidden;

    .Ministerbackground {
        background: #d7f0dbff;
    }

    .Minister-top-top {
        width: 100%;
        height: 40px;

        .Minister-top-left {
            width: 80px;
            line-height: 40px;
            float: left;
            text-align: center;
            font-size: 16px;
            color: #fff;
        }

        .bianti_desc {
            line-height: 40px;
            font-size: 16px;
        }

        .Minister-top-color {
            // color: #567801;
            background: #39b54a;
        }
    }

    .information_content {
        width: calc(100% - 22px);
        overflow: hidden;
        padding: 10px 10px;
        border: 1px solid rgba(168, 168, 168, 0.8);
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-top: none !important;
    }
}

.item_header_title {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    .item_bitian {
        color: red;
    }
}

.image_input_tip_slot {
    .item_click_slot {
        font-size: 16px;
        padding: 0 10px;
        line-height: 30px;
        align-items: center;
        cursor: pointer;
    }

    .item_click_slot:hover {
        background: rgb(254, 225, 136);
    }
}

.table_image_box {
    display: flex;
    flex-wrap: nowrap;
}

.item_image_box {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    cursor: pointer;
}

.item_image_box2 {
    width: 40px;
    height: 40px;
    cursor: pointer;
}

.cur {
    cursor: pointer;
}

.rs-tab {
    width: 853px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    margin-top: 10px;
    padding: 10px 0;
    line-height: 25px;
}

.rs-tab li {
    display: inline-block;
}

.flex {
    display: flex;
}

.image-container {
    display: flex;
    flex-wrap: wrap;

    .img-box {
        width: 178px;
        height: 178px;
        margin-right: 10px;
        margin-bottom: 10px;
        border: 1px solid #eee;
        border-radius: 6px;
        position: relative;
        &:hover .mask{
            background: rgba(0, 0, 0, 0.5);
        }
        .mask {
            width: 100%;
            height: 20%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(0, 0, 0, 0.2);
            position: absolute;
            bottom: 0;
            left: 0;
            transition-duration: 0.5s;
            .custom-icon {
                font-size: 20px;
                margin: 0 8px;
                color: #fff;
            }
        }

        img {
            width: 100%;
            height: 100%;
        }
        &.active img {
            border-color: #409eff; /* 蓝色边框 */
        }
        /* 伪类显示对勾 */
        &.active::after {
            content: "✔";
            position: absolute;
            top: 5px;
            right: 5px;
            color: white;
            background-color: #409eff;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            font-size: 14px;
            font-weight: bold;
        }
    }
}

.checked-img-container {
    width: 100%;
    height: 36px;
    display: flex;
    align-items: flex-end;
    margin-bottom: 5px;

    .img-box {
        width: 28px;
        height: 28px;
        border-radius: 4px;
        position: relative;
        margin-right: 10px;
        line-height: 28px;

        img {
            width: 100%;
            height: 100%;
            border: 1px solid #dcdfe6;
        }

        .el-icon-circle-close {
            display: none;
            position: absolute;
            right: -7px;
            top: -7px;
            color: #999;
            font-size: 14px;
            font-weight: 700;
            cursor: pointer;
        }

        &:hover .el-icon-circle-close {
            display: block;
        }
    }
}

.el-table {
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
        width: 10px;
        /*滚动条宽度*/
        height: 10px;
        /*滚动条高度*/
    }

    /*定义滚动条轨道 内阴影+圆角*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
        // box-shadow: 0px 1px 3px #635757 inset;
        /*滚动条的背景区域的内阴影*/
        border-radius: 10px;
        /*滚动条的背景区域的圆角*/
        background-color: white;
        /*滚动条的背景颜色*/
    }

    /*定义滑块 内阴影+圆角*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
        box-shadow: 0px 1px 3px #635757 inset;
        /*滚动条的内阴影*/
        border-radius: 10px;
        /*滚动条的圆角*/
        background-color: #635757;
        /*滚动条的背景颜色*/
    }
}
/deep/ .img-dialog{
    .el-dialog__body{
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        max-height: none;
    }
}
.dialog-img{
    height: 860px;
    width: 860px;
    object-fit: contain;
}
.btns{
    margin-bottom: 10px;
}
</style>